// extracted by mini-css-extract-plugin
module.exports = {"label":"app-select-group_label_2dDXZ"};